// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3J5eE","badges":"styles_badges__1zTUK"};